var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow32(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2335_35488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0006 16H30.0589L16.7461 30H29.9761L30.0379 29.937L44.0006 16Z",
    fill: "url(#paint0_linear_2335_35488)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0373 29.937L29.9755 30H30.1003L30.0373 29.937Z",
    fill: "url(#paint1_linear_2335_35488)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0583 16H16V30.784V30H16.7455L30.0583 16Z",
    fill: "url(#paint2_linear_2335_35488)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9755 30H16.7455L16 30.784V44L29.9755 30Z",
    fill: "url(#paint3_linear_2335_35488)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1003 30H29.9755L16 44H44L30.1003 30Z",
    fill: "url(#paint4_linear_2335_35488)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7455 30H16V30.784L16.7455 30Z",
    fill: "url(#paint5_linear_2335_35488)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2335_35488",
    x1: 11.0032,
    y1: 41.5881,
    x2: 37.0586,
    y2: 15.5327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C757BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#C757BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#CD5CA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#E8744F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#F88316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#FF8900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2335_35488",
    x1: 25.0451,
    y1: 49.0437,
    x2: 37.745,
    y2: 36.3438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#00AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#5282FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2335_35488",
    x1: 15.7047,
    y1: 23.7381,
    x2: 24.6138,
    y2: 14.8288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#00AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#5282FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2335_35488",
    x1: 11.1589,
    y1: 41.7445,
    x2: 37.2144,
    y2: 15.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD4CA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#AD4CA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#B25093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#CA6545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#D87213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#DE7700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE7700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2335_35488",
    x1: 25.0451,
    y1: 49.0436,
    x2: 37.745,
    y2: 36.3437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0098DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#0098DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#4771DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8151DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2335_35488",
    x1: 19.2061,
    y1: 27.2394,
    x2: 28.1152,
    y2: 18.3301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0098DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#0098DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#4771DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8151DE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2335_35488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow32);
export default __webpack_public_path__ + "static/media/row-3-2.529a4ea36f9caa33261e2f1c9285b9cf.svg";
export { ForwardRef as ReactComponent };